import { Link } from 'react-router-dom';
import { StarFill } from 'react-bootstrap-icons';

const Logo = props => {
    return (
        <Link to="/">
            <h1 className="logo my-3">
                {/* <span>Reunify<StarFill /></span> */}
                <img src="./temp_logo.png" />
            </h1>
        </Link>
    );
}

export default Logo;
